<!-- 最小孔径 -->
<template>
  <BaseFormItem
    :unit="fields.unit"
    :label="fields.label"
    :labelTips="fields.labelTips"
  >
    <BaseRadioGroup v-model="val" @change="handleEmit">
      <el-radio-button
        v-for="item in options"
        :key="item.value"
        :label="item.value"
        :disabled="item.disabled"
      >{{ item.label }}</el-radio-button>
    </BaseRadioGroup>
    <img slot="other" :src="require('@@/assets/img/pcb/vias_view.jpg')" />
  </BaseFormItem>
</template>

<script>
import { getROGERSFields } from '@@/utils/getFields'
import { alertFieldsTips } from '@@/utils/alertFieldsTips'

export default {
  props: {
    value: {
      type: [String, Number],
      default: 0.3
    },
    // 板子厚度
    bheight: {
      type: Number
    },
    // 返回修改初始化参数时，参数不进行关联变更
    initPcbParamsChange: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      val: +this.value
    }
  },
  computed: {
    fields() {
      return getROGERSFields('vias')
    },
    options() {
      const { bheight, fields } = this
      let options = [...fields.options]
      // 板子厚度 > 1.6 时，禁用 0.15 选项
      return options.map(item => ({...item, disabled: item.value == 0.15 && bheight > 1.6}))
    }
  },
  watch: {
    value(newVal) {
      this.val = +newVal
    },
    bheight(bheight) {
      if (bheight > 1.6 && this.val == 0.15) {
        this.changeVal(0.3)
      }
    }
  },
  methods: {
    handleEmit() {
      const val = this.val
      this.$emit('input', val)
      this.$emit('change', val)
    },
    changeVal(val) {
      if (this.initPcbParamsChange) return
      alertFieldsTips(this.fields.label)
      this.val = val
      this.handleEmit()
    }
  }
}
</script>

<style lang="scss" scoped>
</style>